/**
 * autoscaling模块接口列表
 */
 import $http from '../utils/http'; // 导入http中创建的axios实例

 const autoscaling = {
    //分页查询弹性伸缩接口
    pageAutoscaling(params) {
        return $http.post(`${global.API_URL}/sme/autoscaling/page`,params);
      },
    //删除
    deleteAuto(id ,params) {
      let param = new URLSearchParams();
      param.append(id, params);
      return $http.post(`${global.API_URL}/sme/autoscaling/deleteById`,param);
    },
    //nat网关详情
    getDetailsById(params) {
    return $http.post(`${global.API_URL}/sme/autoscaling/getDetailsById`,params);
  },
 }
 
 export default autoscaling;
 


// WEBPACK FOOTER //
// ./src/api/autoscaling.js